export default [{
    value: '',
    label: '全部'
}, {
    value: '1',
    label: '平台账户'
}, {
    value: '2',
    label: '服务费账户'
}, {
    value: '3',
    label: '奖励红包账户'
}, {
    value: '4',
    label: '冻结账户'
}, {
    value: '5',
    label: '营销账户'
}];



// WEBPACK FOOTER //
// ./src/service/constant/AcctTypes.js